<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('autocaller_v2.campaign.filter.name.title') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.search" :clearable="true" />
        </div>
      </div>
      <select-status v-model="form.active" class="col-3" />
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('autocaller_v2.campaign.filter.type.title') }}
        </label>
        <div class="filter__item__body">
          <select-type v-model="form.type" />
        </div>
      </div>

      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('autocaller_v2.campaign.filter.caller_id.title') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.callers" :clearable="true" />
        </div>
      </div>
      <div class="filter__item filter__item--button">
        <i-button html-type="submit" type="primary">
          {{ $t('shared.component.filter.show_result') }}
        </i-button>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import SelectStatus from './campaigns-filter-status';
  import SelectType from './campaigns-filter-type';
  import FilterWrapper from '@shared/components/filter-base';
  import { mapActions } from 'vuex';

  export default {
    components: {
      FilterWrapper,
      SelectStatus,
      SelectType
    },
    data: () => ({
      numbers: [],
      form: {
        search: '',
        caller_id: '',
        active: '',
        type: '',
        date: {
          start: null,
          end: null
        }
      }
    }),
    computed: {
      is_pbx_allow: function () {
        return this.$permission.module_pbx_is_allowed;
      }
    },

    created() {
      this.submit();
    },

    methods: {
      ...mapActions('autocaller_v2/campaigns/table', ['search']),
      submit: function () {
        const { search = '', active, type, callers } = this.form;

        const params = {
          name: search,
          active,
          type,
          callers
        };
        if (params.active === '') {
          delete params.active;
        }
        if (params.callers === '') {
          delete params.callers;
        }
        this.search(params);
      }
    }
  };
</script>
